import generateTypes from '../utils/generateTypes';

export const GET_GAMIFICATIONS = generateTypes('GET_GAMIFICATIONS');
export const RESET_GAMIFICATIONS = generateTypes('RESET_GAMIFICATIONS');
